import { Button, InputField, Tooltip } from "components";
import { header } from "components/atoms/HeaderTableContainer";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { handleToggleExport } from "store/slices/ui.slice";
import constants from "utils/constants";
import { useTable } from "utils/hooks/useTable";
import { schema } from './schema'
import { zodResolver } from "@hookform/resolvers/zod";

export const PulseHeader = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { count } = useAppSelector((state) => state.insights.leads);
    const { exportOpen, filterOpen } = useAppSelector((state) => state.ui);
    const { totalItemsSelecteds } = useTable({ totalItems: count });
    const { base, nav } = header({ isExport: exportOpen, sidebarOpen: filterOpen });

    const form = useForm({
        resolver: zodResolver(schema)
    })
    const handleSubmit = (data: { search?: string }) => {
        const { search } = data;

        const params = new URLSearchParams(window.location.search);

        if (search === undefined || !search.trim()) {
            form.reset();
            params.delete('search_name');
        } else {
            params.set('search_name', search)
            form.resetField('search');
        }

        navigate(`?${params.toString()}`);
    };
    return (
        <div data-tesid="pulse-header" className={base()}>
            <div className={nav()}>
                <FormProvider {...form}>
                    <form
                        className="flex flex-row gap-4"
                        onSubmit={form.handleSubmit(handleSubmit)}>
                        <Controller
                            name="search"
                            render={({ field }) => (
                                <InputField
                                    {...field}
                                    placeholder='Search by keywords'
                                    size='tiny'
                                    style={{ minWidth: '130px', }}
                                />
                            )}
                        />
                        <Button iconName='search' iconSize={16} size='xs' action="submit" >Search</Button>
                    </form>
                </FormProvider>
                <div className='flex items-center text-sm gap-5'>
                    {totalItemsSelecteds > 0 &&
                        <div className='flex items-center gap-5' data-testid='pulse-header-selected'>
                            <p className='text-gray-400'>
                                <b className='text-white-500'>
                                    {totalItemsSelecteds > 0 ? Number((count > constants.LIMIT_ENRICHMENT_ATTEMPT_PER_TASK ? constants.LIMIT_ENRICHMENT_ATTEMPT_PER_TASK : totalItemsSelecteds)) : totalItemsSelecteds}
                                </b>{' '}
                                selected
                            </p>
                            <Tooltip content='Export selected leads to CSV'>
                                <Button data-testid='export-button' iconName='download' size='xs' className='float-right' onClick={() => dispatch(handleToggleExport())}>Export</Button>
                            </Tooltip>
                        </div>
                    }
                    <Button data-testid="button-export-list" onClick={() => navigate('/exports')} iconName='document' size='xs'>Export Lists</Button>
                </div>
            </div>
        </div>
    )
}
